import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const AuthGuard = ({ children } : {children: ReactNode}) => {
  const { isAuthenticated } = useAuth();

  // اگر کاربر وارد نشده بود، او را به صفحه ورود هدایت کن
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // در غیر این صورت، کامپوننت فرزند (مثلاً صفحه داشبورد) را نمایش بده
  return <>{children}</>;
};

export default AuthGuard;
